import { render, staticRenderFns } from "./SingleSelectLehrgang.vue?vue&type=template&id=4d7d80cc&"
import script from "./SingleSelectLehrgang.vue?vue&type=script&lang=js&"
export * from "./SingleSelectLehrgang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports